import catData from './shared/state';

export default {
  modules: {
    catData,
  },
};
